import { atom } from 'jotai';
import { Node, Edge } from '@/features/connect-dots/types/cytoscape';

export type FinalNetwork = {
  nodes: Node[];
  edges: Edge[];
};

export const networkAtom = atom<FinalNetwork | null>(null);
